<mat-card>
  <mat-card-header>
    <div mat-card-avatar>
      <mat-icon>{{ cardIcon }}</mat-icon>
    </div>
    <mat-card-title>{{ cardTitle }}</mat-card-title>
    <mat-card-subtitle class="card-subtitle">{{
      cardSubTitle
    }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
  <mat-card-actions>
    @if (buttonType === 'flat') {
      @if (cardLinkUrl) {
        <a mat-flat-button color="primary" [routerLink]="cardLinkUrl">
          <span>{{ cardLinkText }}</span>
          @if (showButtonIcon) {
            <mat-icon>{{ cardIcon }}</mat-icon>
          }
        </a>
      }
    } @else {
      @if (cardLinkUrl) {
        <a mat-stroked-button color="primary" [routerLink]="cardLinkUrl">
          <span>{{ cardLinkText }}</span>
          @if (showButtonIcon) {
            <mat-icon>{{ cardIcon }}</mat-icon>
          }
        </a>
      }
    }
  </mat-card-actions>
</mat-card>
